<ng-container [ngSwitch]="currentStep">
    <div class="stepper-header">
        <div class="stepper-header-title">
            <span>{{ sectionTitle }}</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="progress" color="primary"></mat-progress-bar>
    </div>
    <lgv-loan-purpose class="step-body" *ngSwitchCase="GettingStartedSteps.LoanPurpose" (stepChange)="goToStep($event)" (closeDialog)="onClose()"></lgv-loan-purpose>
    <lgv-homebuying-status class="step-body" *ngSwitchCase="GettingStartedSteps.HomebuyingStatus" (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)" (closeDialog)="onClose()"></lgv-homebuying-status>
    <lgv-refinance-goals class="step-body" *ngSwitchCase="GettingStartedSteps.RefinanceGoals" (stepChange)="goToStep($event)" (sectionChange)="goToSection($event)"></lgv-refinance-goals>
</ng-container>